<!-- part one starts here-->
<div class="background" id="background">
  <nav class="navbar navbar-submit animate__animated animate__slideInDown" id="nav">
    <a class="Ws-logo" [routerLink]="['/home']">{{ constants.WINDOW_SWAP_TXT }}</a>
    <!-- <img [routerLink]="['/user']" class="profile-avatar" src="{{ constants.USER_ICON }}" /> -->
    <!-- <app-user-menu *ngIf="from === 'submit' || from === 'submit-1' "  [from]="from">
    </app-user-menu> -->
    <app-user-menu  [from]="newFrom"></app-user-menu>

  </nav>
  <nav class="navbar navbar-submit-mob animate__animated animate__slideInDown" id="nav-mob">
    <img [routerLink]="['/user']" class="profile-avatar" src="{{ profilePicture }}" />
    <a class="Ws-logo" [routerLink]="['/home']">{{ constants.WINDOW_SWAP_TXT }}</a>
    <!-- <div></div> -->
    <a></a>
  </nav>
  <div class="container section" *ngIf="from === constants.SUBMIT_SMALL_TXT">
    <div class="row section-row">
      <div class="col section-col-info">
        <h1 class="title-box-1 animate__animated animate__fadeInUp" id="title-box-1">
          {{ constants.HOW_TO_TXT }}
        </h1>
        <ol class="text-box">
          <li class="animate__animated animate__fadeInUpBig submit-text">
            {{ constants.HOW_TO_CONTENT_1_TXT }}
          </li>
          <li class="animate__animated animate__fadeInUpBig submit-text">
            {{ constants.HOW_TO_CONTENT_2_TXT }}
          </li>
          <li class="animate__animated animate__fadeInUpBig submit-text">
            {{ constants.HOW_TO_CONTENT_3_TXT }}
          </li>
        </ol>
        <div class="query animate__animated animate__fadeInUpBig">
          <img src="{{ constants.MAIL_IMG }}" />
          <div>{{constants.QUERY_TXT}}</div>
          <a href="mailto:{{constants.QUNALIAA_EMAIL_TXT}}" target="_blank">{{constants.QUNALIAA_EMAIL_TXT}}</a>
        </div>
      </div>
      <div class="col-12 col-md-6 section-drag-col">
        <div class="drag-area" id="drag-area" ngx-dropzone [accept]="'video/*, video/quicktime'"
          (change)="onSelect($event)" [multiple]="false" accept="" [maxFileSize]="constants.MAX_SIZE_NUM">
          <ngx-dropzone-label class="dropzone-label">
            <div id="drop-button-area">
              <div class="icon" id="plus-icon">
                <img [src]="constants.ADD_BUTTON_IMG" alt="" />
              </div>
              <h2 class="drag-title drag-title-desktop" id="drag-title">
                {{constants.DRAG_AND_DROP_TXT}} <br />
                or {{constants.HIT_PLUS}}
              </h2>
              <h2 class="drag-title drag-title-medium" id="drag-title">
                {{constants.HIT_PLUS}}
              </h2>
              <h2 class="drag-title drag-title-mobile" id="drag-title">
                {{constants.HIT_PLUS_MOB}}
              </h2>
              <img class="drag-ondrop" id="drag-ondrop" [src]="constants.ON_DROP_IMG" alt="" />
            </div>
          </ngx-dropzone-label>
        </div>
        <button class="row small-text-container">
          <div class="col small-text-col1">
            <span class="small-text">{{constants.RESPECT_TXT}}</span>
          </div>
          <div class="col small-text-col2">
            <span class="small-text">{{constants.ONLY_UPLOAD}}</span>
          </div>
          <div class="col small-text-col3">
            <span class="small-text">{{constants.ZERO_TOLL_TXT}}</span>
          </div>
        </button>
      </div>
    </div>
  </div>
  <!-- part one ends here -->
  <!-- part two starts here -->
  <div class="container inner-container" id="section-no-error" *ngIf="from === 'submit-1'">
    <form [formGroup]="submitForm" (ngSubmit)="submitform($event)" class="" id="contain">
      <div class="row mobile-style">
        <div class="col-12 col-md-6 drag-zone-container" id="style-mobile">
          <div class="row drag-row-height">
            <div class="progress-area" id="drag-area">
              <div class="dropzone-label">
                <div id="drop-button-area" class="drop-button-center">
                  <h2 class="progress-title" id="progress-title">
                    {{constants.READY_FOR_TXT}} <br> {{constants.TO_BE_UPLOADED}}
                  </h2>
                  <div class="icon-success" id="plus-icon">
                    <img [src]="constants.APPROVED_WINDOW" alt="" />
                  </div>
                  <h2 class="progress-title-bottom" id="progress-title" *ngIf="hideText">
                    {{constants.PLEASE_START_TXT}}<br>{{constants.HIT_UPLOAD}}
                  </h2>
                  <button class="error-cancel-button" id="err-btn">
                    <a href="/submit" class="error-cancel">{{constants.CANCEL_TXT}}</a>
                  </button>
                  <div class="progress progress-bar-background" id="progress-bar-background">
                    <div class="progress-bar progress-bar-progress" id="progressbar" role="progressbar"
                      attr.aria-valuenow="{{ progressLoading }}" aria-valuemin="0" aria-valuemax="100">
                    </div>
                  </div>
                  <h2 class="progress-count" id="progressSpan"></h2>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 drag-zone-container" id="message-mobile">
          <div id="message-mobile-container">
            <div class="icon-mobile" id="plus-icon">
              <img [src]="constants.READY_TO_UPLOAD_IMG" alt="" />
            </div>
            <h2 class="progress-title-mobile" id="progress-title-mobile">
              {{constants.READY_FOR_TXT}}<br />{{constants.PLEASE_ADD_TXT}}
            </h2>
            <button class="error-cancel-button" id="err-btn-mob">
              <a href="/submit" class="error-cancel">{{constants.CANCEL_TXT}}</a>
            </button>
          </div>
        </div>
        <div class="col-md-6 col-12 form-area" id="mobile-form">
          <div class="row animate__animated animate__fadeInUp">
            <div class="Nickname col">
              <label for="nickname" class="input-title">{{constants.NICKNAME_TXT}}</label>
              <span class="error" *ngIf="
                  submitForm.get('nickName').errors?.required ||
                  (submitForm.get('nickName').dirty ||
                    submitForm.get('nickName').touched)
                ">
                *</span>
                <input placeholder="e.g Mungus" type="text" id="nickname" class="form-control" formControlName="nickName" (input)="nicknameValidationError = false"/>            
                <span class="error-message" *ngIf="submitForm.get('nickName').errors?.maxlength">{{constants.NAME_MAXLENGTH_ERROR_TEXT}}</span>
                <span class="error-message" *ngIf="nicknameValidationError">Please enter valid name</span>
              </div>

            <div class="col"></div>
          </div>
          <div class="row animate__animated animate__fadeInUp mt-15" >
            <div class="col m-b">
              <label for="location" class="input-title">{{constants.LOCATION_TXT}}</label>
              <span class="error" *ngIf="
                  submitForm.get('location').errors?.required ||
                  (submitForm.get('location').dirty ||
                    submitForm.get('location').touched)
                ">
                *</span>
              <input placeholder="e.g Espoo, Uusimaa" type="text" id="location" class="form-control"
                formControlName="location" (input)="locationValidationError = false"/>
                <span class="error-message" *ngIf="submitForm.get('location').errors?.maxlength">{{constants.LOCATION_MAXLENGTH_ERROR_TEXT}}</span>
                <span class="error-message" *ngIf="locationValidationError">Please enter valid location</span>
            </div>
            <div class="col">
              <label for="country" class="input-title">{{constants.COUNTRY_TXT}}</label>
              <span class="error" *ngIf="
                  submitForm.get('country').errors?.required ||
                  (submitForm.get('country').dirty ||
                    submitForm.get('country').touched)
                ">
                *</span>
              <select aria-placeholder="test" id="inputState" class="form-control m-b" formControlName="country">
                <option [value]="" selected hidden>{{constants.SELECT_COUNTRY_TXT}}</option>
                <option *ngFor="let Country of constants.COUNTRY_LIST_TXT">
                  {{ Country["countryName"] }}
                </option>
              </select>
            </div>
          </div>
          <div class="row animate__animated animate__fadeInUp mt-15" >
            <div class="col">
              <label for="timeRecording" class="input-title">{{constants.RECORDING_TIME_TXT}}</label>
              <span class="error">
                *</span>
              <input placeholder="10:35PM" type="time" id="timeRecording" class="form-control m-b"
                formControlName="timeRecording" [(ngModel)]="defaultTime" />
            </div>
            <div class="col">
              <label for="dateRecording" class="input-title">{{constants.RECORDING_DATE_TXT}}</label>
              <span class="error" *ngIf="
                submitForm.get('dateRecording').errors?.required ||
                (submitForm.get('dateRecording').dirty ||
                  submitForm.get('dateRecording').touched)
                  ">
                *</span>
              <input placeholder="dd/mm/yyyy" type="date" [max]="maxDate" id="dateRecording" class="form-control m-b"
                formControlName="dateRecording" />
            </div>
          </div>
          <div class="mt-15">
            <p class="input-title animate__animated animate__fadeInUp">
              {{constants.TAG_WINDOW_TXT}}
            </p>
          </div>
          <div class="tag-area animate__animated animate__fadeInUp mt-25" formGroupName="tags">
            <div class="checkbox-button" [ngClass]="{ 'checkbox-button-active': tagList.animalsActive }">
              <input class="tag-checkbox" id="animals" type="checkbox" formControlName="{{constants.ANIMALS_TXT}}" />
              <img class="checkbox-img" [src]="constants.CHECKBOX_IMG" alt="" />
              <img class="checkbox-close" [src]="constants.CLOSE_IMG" alt="" />
              <label for="animals" id="animals-label" class="label-text"
                (click)="setTag('animalsActive')">{{constants.ANIMALS_TXT}}</label>
            </div>
            <div class="checkbox-button" [ngClass]="{ 'checkbox-button-active': tagList.rainActive }">
              <input class="tag-checkbox" id="rain" type="checkbox" formControlName="{{constants.RAIN_TXT}}" />
              <img class="checkbox-img" [src]="constants.CHECKBOX_IMG" alt="" />
              <img class="checkbox-close" [src]="constants.CLOSE_IMG" alt="" />
              <label for="rain" id="rain-label" class="label-text"
                (click)="setTag('rainActive')">{{constants.RAIN_TXT}}</label>
            </div>
            <div class="checkbox-button" [ngClass]="{ 'checkbox-button-active': tagList.snowActive }">
              <input class="tag-checkbox" id="snow" type="checkbox" formControlName="{{constants.SNOW_TXT}}" />
              <img class="checkbox-img" [src]="constants.CHECKBOX_IMG" alt="" />
              <img class="checkbox-close" [src]="constants.CLOSE_IMG" alt="" />
              <label for="snow" id="snow-label" class="label-text"
                (click)="setTag('snowActive')">{{constants.SNOW_TXT}}</label>
            </div>
            <div class="checkbox-button" [ngClass]="{ 'checkbox-button-active': tagList.cityActive }">
              <input class="tag-checkbox" id="city" type="checkbox" formControlName="{{constants.CITY_TXT}}" />
              <img class="checkbox-img" [src]="constants.CHECKBOX_IMG" alt="" />
              <img class="checkbox-close" [src]="constants.CLOSE_IMG" alt="" />
              <label for="city" id="city-label" class="label-text"
                (click)="setTag('cityActive')">{{constants.CITY_TXT}}</label>
            </div>
            <div class="checkbox-button" [ngClass]="{ 'checkbox-button-active': tagList.natureActive }">
              <input class="tag-checkbox" id="nature" type="checkbox" formControlName="{{constants.NATURE_TXT}}" />
              <img class="checkbox-img" [src]="constants.CHECKBOX_IMG" alt="" />
              <img class="checkbox-close" [src]="constants.CLOSE_IMG" alt="" />
              <label for="nature" id="nature-label" class="label-text"
                (click)="setTag('natureActive')">{{constants.NATURE_TXT}}</label>
            </div>
            <div class="checkbox-button" [ngClass]="{ 'checkbox-button-active': tagList.nightActive }">
              <input class="tag-checkbox" id="night" type="checkbox" formControlName="{{constants.NIGHT_TXT}}" />
              <img class="checkbox-img" [src]="constants.CHECKBOX_IMG" alt="" />
              <img class="checkbox-close" [src]="constants.CLOSE_IMG" alt="" />
              <label for="night" id="night-label" class="label-text"
                (click)="setTag('nightActive')">{{constants.NIGHT_TXT}}</label>
            </div>
            <div class="checkbox-button" [ngClass]="{ 'checkbox-button-active': tagList.dayActive }">
              <input class="tag-checkbox" id="day" type="checkbox" formControlName="{{constants.DAY_TXT}}" />
              <img class="checkbox-img" [src]="constants.CHECKBOX_IMG" alt="" />
              <img class="checkbox-close" [src]="constants.CLOSE_IMG" alt="" />
              <label for="day" id="day-label" class="label-text"
                (click)="setTag('dayActive')">{{constants.DAY_TXT}}</label>
            </div>

            <div class="checkbox-button" [ngClass]="{ 'checkbox-button-active': tagList.interiorActive }">
              <input class="tag-checkbox" id="interior" type="checkbox" formControlName="{{constants.INTERIORS_TXT}}" />
              <img class="checkbox-img" [src]="constants.CHECKBOX_IMG" alt="" />
              <img class="checkbox-close" [src]="constants.CLOSE_IMG" alt="" />
              <label for="interior" id="interior-label" class="label-text" (click)="setTag('interiorActive')">
                {{constants.INTERIORS_TXT}}</label>
            </div>
            <div class="checkbox-button" [ngClass]="{ 'checkbox-button-active': tagList.waterActive }">
              <input class="tag-checkbox" id="water" type="checkbox" formControlName="{{constants.WATER_TXT}}" />
              <img class="checkbox-img" [src]="constants.CHECKBOX_IMG" alt="" />
              <img class="checkbox-close" [src]="constants.CLOSE_IMG" alt="" />
              <label for="water" id="water-label" class="label-text" (click)="setTag('waterActive')">
                {{constants.WATER_TXT}}</label>
            </div>
          </div>
          <!-- <div class="row animate__animated animate__fadeIn" formGroupName="collabs">
            <div class="animate__animated animate__fadeInUp">
              <p class="input-title-collab">{{constants.COLLAB_PARA_TXT}}</p>
            </div>
            <div class="tag-area animate__animated animate__fadeInUp">
              <input [(ngModel)]="collabYes" name="collab" id="yes" type="checkbox" class="collab-checkbox"
                formControlName="Yes" (click)="collabOnchange(true)" />
              <label class="collab-checkbox-label" for="yes">{{constants.YES}}</label>
              <input [(ngModel)]="collabNo" name="collab" id="no" type="checkbox" class="collab-checkbox"
                formControlName="No" (click)="collabOnchange(false)" />
              <label class="collab-checkbox-label" for="no">{{constants.NO}}</label>
            </div>
          </div> -->
          <div class="progress-bottom animate__animated animate__fadeInUp mt-15" >
            <input formControlName="terms" type="checkbox" id="terms" class="terms-checkbox" />
            <label for="terms" class="terms-checkbox-label">{{constants.I_ACCEPT_TXT}}
              <a [href]="constants.TERMS_CONDITIONS_LINK">{{constants.TANDC_TXT}}</a></label>
          </div>
          <div class="submit-button animate__animated animate__fadeInUp" >
            <button id="progress-button" [disabled]="isDisable || !submitForm.valid" class="progres-button">
              Upload
            </button>
            <button class="submit-cancel-button">
              <a href="/submit" class="submit-cancel">{{constants.CANCEL_TXT}}</a>
            </button>
          </div>
        </div>
       
          <div id="mobile-cancel-retry" class="submit-button animate__animated animate__fadeInUp" *ngIf="showRetyForMobile">
            <button id="progress-button"  class="progres-button">
              Re-upload
            </button>
            <button class="submit-cancel-button">
              <a href="/submit" class="submit-cancel">{{constants.CANCEL_TXT}}</a>
            </button>
          </div>
          <div id="mobile-cancel">
            <button class="submit-cancel-button" *ngIf="!showRetyForMobile">
              <a href="/submit" class="submit-cancel-mobile">{{constants.CANCEL_TXT}}</a>
            </button>
          </div>
      </div>
    </form>
  </div>
  <!-- part two ends here -->


  <!-- error part -->
  <div class="container section-error" id="section-error">
    <div class="row section-row">
      <div class="col section-col-info">
        <h1 class="title-box-1 " id="title-box-1">
          {{ constants.HOW_TO_TXT }}
        </h1>
        <ol class="text-box">
          <li class=" submit-text">
            {{ constants.HOW_TO_CONTENT_1_TXT }}
          </li>
          <li class="submit-text">
            {{ constants.HOW_TO_CONTENT_2_TXT }}
          </li>
          <li class=" submit-text">
            {{ constants.HOW_TO_CONTENT_3_TXT }}
          </li>
        </ol>
        <div class="query ">
          <img src="{{ constants.MAIL_IMG }}" />
          <div>{{constants.QUERY_TXT}}</div>
          <a href="mailto:{{constants.QUNALIAA_EMAIL_TXT}}" target="_blank">{{constants.QUNALIAA_EMAIL_TXT}}</a>
        </div>
      </div>
      <div class="col-12 col-md-6 section-error-col">
        <div class="error-area">
          <div class="close-icon">
            <img [src]="constants.CLOSE_ICON_SUBMIT" alt="close" class="close-icon-img" (click)="goback()" />
          </div>
          <div class="icon" id="plus-icon">
            <img [src]="constants.LOWRES_VIDEO" alt="error" id="error-video-length-image" />
            <img [src]="constants.VERTICAL_VIDEO" alt="error" id="error-video-potrait-image">
            <img [src]="constants.LOWRES_VIDEO" alt="error" id="error-video-lowres-image" />
            <h2 class="error-video-lowres" id="error-video-lowres">
              <span class="first-head">Oops! That’s a low-res video.</span><br /><span class="second-head ">Please
                upload
                a video that’s <br /> clear for all to see.</span>
            </h2>
            <h2 class="error-video-potrait" id="error-video-potrait">
              <span class="first-head">Oops! That’s a vertical video! </span><br /><span class="second-head ">please
                upload only <br /> horizontally shot videos.</span>
            </h2>
            <h2 class="error-video-length" id="error-video-length">
              <span class="first-head">Oops! That’s a short video! </span><br /><span class="second-head ">Please upload
                a
                video <br /> that is at least 3 minutes long.</span>
            </h2>
            <h2 class="error-video-lowres" id="error-video-lowres">
              <span class="first-head">Oops! That’s a low-res video.</span><br /><span class="second-head ">Please
                upload
                a video that’s <br /> clear for all to see.</span>
            </h2>
          </div>
        </div>
        <button class="row small-text-container-error ">
          <div class="col small-text-col1">
            <span class="small-text">{{constants.RESPECT_TXT}}</span>
          </div>
          <div class="col small-text-col2">
            <span class="small-text">{{constants.ONLY_UPLOAD}}</span>
          </div>
          <div class="col small-text-col3">
            <span class="small-text">{{constants.ZERO_TOLL_TXT}}</span>
          </div>
        </button>
      </div>
    </div>
  </div>
  <div class="container section" id="mob-error">
    <div class=""></div>
    <div class="icon" id="plus-icon">
      <img [src]="constants.LOWRES_VIDEO" alt="error" id="error-video-length-mob-image" />
      <img [src]="constants.VERTICAL_VIDEO" alt="error" id="error-video-potrait-mob-image">
      <img [src]="constants.LOWRES_VIDEO" alt="error" id="error-video-lowres-mob-image" />
      <h2 class="error-video-lowres" id="error-video-lowres-mob">
        <span class="first-head">Oops! <br /> That’s a low-res video.</span><br /><span class="second-head "
          id="second">Please
          upload
          a video that’s clear for all to see.</span>
      </h2>
      <h2 class="error-video-potrait" id="error-video-potrait-mob">
        <span class="first-head">Oops! <br /> That’s a vertical video! </span><br /><span class="second-head "
          id="second">please
          upload only horizontally shot videos.</span>
      </h2>
      <h2 class="error-video-length" id="error-video-length-mob">
        <span class="first-head">Oops! <br /> That’s a short video! </span><br /><span class="second-head "
          id="second">Please
          upload
          a
          video that is at least 3 minutes long.</span>
      </h2>
    </div>
    <button class="okay-button" (click)="goback()" id="okay">Okay</button>
  </div>
  <!-- error ends here -->
</div>
<div class="success-background" *ngIf="from === 'submit-step3' || from === 'submit-step4'">
  <nav class="navbar navbar-success animate__animated animate__fadeInDown">
    <a class="Ws-logo-success" [routerLink]="['/home']">{{ constants.WINDOW_SWAP_TXT }}</a>
    <img [routerLink]="['/user']" class="profile-avatar" src="{{ profilePicture }}" />
  </nav>
  <!-- part three starts here -->
  <div class="container container-background" *ngIf="from === 'submit-step3'">
    <div class="row">
      <div class="col-md-6 col-12 d-flex align-items-center justify-content-center animate__animated animate__fadeInUp">
        <img class="thank-img" src="{{ constants.SUBMIT_THANK_IMG }}" alt="" />
      </div>
      <div class="col-md-6 col-12 thank-content animate__animated animate__fadeInUp">
        <p class="para-spacing">
          {{constants.SUBMIT_THANK_1_TXT}}<br />{{constants.SUBMIT_THANK_2_TXT}}
        </p>
        <p class="para-spacing">
          {{constants.SUBMIT_THANK_PARA_1_TXT}}<br />{{constants.SUBMIT_THANK_PARA_2_TXT}}
        </p>
        <p class="para-spacing">{{constants.SUBMIT_THANK_PARA_3_TXT}}</p>
        <a class="thank-link" [routerLink]="['/user/mywindow']"><button
            class="thank-button">{{constants.VIEW_PROF_BUTTON_TXT}}</button></a>
      </div>
    </div>
  </div>
  <!-- part three ends here -->
  <!-- part four starts here -->
  <div class="container container-background-last animate__animated animate__fadeInUp" *ngIf="from === 'submit-step4'">
    <img class="success-img" src="{{ constants.SUBMIT_THANK_IMG_1 }}" alt="" />
    <h1 class="success-title">{{constants.CRETOR_THANK_1_TXT}}<br />{{constants.CRETOR_THANK_2_TXT}}</h1>
    <p class="desk-succes">
      {{constants.CRETOR_THANK_PARA1_TXT}}<br />{{constants.CRETOR_THANK_PARA2_TXT}}
    </p>
    <p class="">{{constants.CRETOR_THANK_PARA4_TXT}}</p>
    <a class="thank-link" [routerLink]="['/user/mywindow']"><button
        class="thank-button">{{constants.VIEW_PROF_BUTTON_TXT}}</button></a>
  </div>
</div>
<!-- part four ends here -->